import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  fetchDataFailure,
  fetchDataSuccess,
  uploadDocSuccess,
  uploadDocFailure,
  fetchData,
} from "../actions";
import { fetchDocsList, uploadFileApi, removeDocApi } from "../../API/API";

function* docSaga(params) {
  try {
    const response = yield call(() => fetchDocsList(params)); // API Backend
    if (response.data.status === true) {
      yield put(fetchDataSuccess(response.data.data.body));
    } else {
      yield put(fetchDataFailure(response.data.status));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

function* uploadDocSaga(params) {
  try {
    const response = yield call(uploadFileApi, params); // API Backend
    // console.log(response.data.data.body);
    if (response.data.status === "success") {
      const data = {
        key: response.data.payload,
        CredentialDocumentId: params.params.documentId,
      };
      yield put(uploadDocSuccess(data));
      // setTimeout(yield put(fetchData()), 3000);
    } else {
      yield put(uploadDocFailure(response.errorMessage));
    }
  } catch (error) {
    console.log(error);
    yield put(uploadDocFailure(error));
  }
}

function* removeDocSaga(params) {
  try {
    const response = yield call(removeDocApi, params); // API Backend
    // console.log(response.data.data.body);
    if (response.status == 200) {
      const data = {
        key: null,
        CredentialDocumentId: params.params.documentId,
      };
      yield put(fetchData());
      // yield put(uploadDocSuccess(data));
    } else {
      yield put(uploadDocFailure(response.errorMessage));
    }
  } catch (error) {
    console.log(error);
    yield put(uploadDocFailure(error));
  }
}

export function* watchDocSaga() {
  yield takeEvery(types.SEND_REQUEST_INIT, docSaga);
}

export function* watchUploadDocSaga() {
  yield takeEvery(types.UPLOAD_DOCUMENT_INIT, uploadDocSaga);
}

export function* watchRemoveDocSaga() {
  yield takeEvery(types.REMOVE_DOCUMENT_INIT, removeDocSaga);
}
